/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnContext } from './en-context';
import { EnPersonType } from './en-person-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateClientDto
 */
export interface CreateClientDto {

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    companyName: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    registeredOfficeAddress: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    postalCode: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    city: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    province: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    nation: string;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateClientDto
     */
    place?: JoinEntityDto;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    telephone: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    vatNumber: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    pec?: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    poc?: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    cuuCode?: string;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    sdiCode?: string;

    /**
     * @type {EnPersonType}
     * @memberof CreateClientDto
     */
    type?: EnPersonType;

    /**
     * @type {EnContext}
     * @memberof CreateClientDto
     */
    context: EnContext;

    /**
     * @type {string}
     * @memberof CreateClientDto
     */
    note?: string;
}
